/* eslint-disable no-case-declarations */
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { getTemplateUrl } from '../../../../ground/assets/js/utilities/paths';

export default class Loader {
	constructor(scene, manager, textures) {
		this.scene = scene;
		this.textures = textures;
		this.manager = manager;
		this.templateUrl = getTemplateUrl() + '-child';
	}

	load(type, modelPath) {

		switch (type) {

		case 'gltf':
			// Instantiate a loader
			const loader = new GLTFLoader();

			// Optional: Provide a DRACOLoader instance to decode compressed mesh data
			const dracoLoader = new DRACOLoader();
			dracoLoader.setDecoderPath( this.templateUrl + '/assets/js/vendors/draco/' );
			dracoLoader.setDecoderConfig( { type: 'js' } );
			loader.setDRACOLoader( dracoLoader );

			// Load a glTF resource
			loader.load(
			// resource URL
			//templateUrl + '/assets/models/monkey/monkey.gltf',
				this.templateUrl + modelPath,
				// called when the resource is loaded
				( gltf ) =>  {
					console.log(gltf);
					this.scene.add( gltf.scene );
				},

				// called while loading is progressing
				function ( xhr ) {

					console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );

				},
				// called when loading has errors
				function ( error ) {

					console.log( 'An error happened', error );

				}
			);

			break;

		}

	}

	update() {
	}

	destroy() {
	}
}
